import type { AutofillItem } from "./types";

export const schedule: AutofillItem[] = [
  {
    keyword: "週末稼働",
    contents: [
      "土日ともにフル稼働しています。",
      "土曜日はフル稼働しています。",
      "土曜日は半日稼働しています。",
      "日曜日はフル稼働しています。",
      "日曜日は半日稼働しています。",
    ],
  },
  {
    keyword: "平日夜稼働",
    contents: [
      "平日は夜間に作業を進めています。",
      "平日夜間の稼働がメインとなります。",
      "平日は日中対応が難しい場合があります。",
    ],
  },
  {
    keyword: "週末休業",
    contents: [
      "土日はお休みをいただいています。",
      "土曜日はお休みをいただいています。",
      "日曜日はお休みをいただいています。",
    ],
  },
  {
    keyword: "午前オフライン",
    contents: [
      "午前中は基本的に対応外です。",
      "午前中はオフラインになることが多いです。",
      "午前中は対応が遅れることがあります。",
    ],
  },
  {
    keyword: "新規受付余裕",
    contents: [
      "現在、新規プロジェクトの受付に余裕があります。",
      "今なら新しい案件もスムーズに対応可能です。",
      "スケジュールに余裕があり、新規案件歓迎です。",
    ],
  },
  {
    keyword: "スケジュール満杯",
    contents: [
      "今月は既にスケジュールが埋まっています。",
      "現在スケジュールが詰まっております。",
      "予約が立て込んでおり、対応にお時間をいただく可能性があります。",
    ],
  },
  {
    keyword: "不定期対応",
    contents: [
      "不定期に連絡可能ですが、日中は難しい場合があります。",
      "稼働日は不定期で、事前にご確認ください。",
      "柔軟な対応が可能ですが、タイミングによって変動します。",
    ],
  },
  {
    keyword: "短期案件優先",
    contents: [
      "短期案件を優先していますが、条件によっては長期も検討可能です。",
      "短期での依頼をメインに受け付けています。",
      "長期案件も可能ですが、基本は短期案件を優先しております。",
    ],
  },
  {
    keyword: "オンラインミーティング",
    contents: [
      "毎週水曜の午後は、オンラインミーティングの調整が可能です。",
      "水曜午後のオンラインミーティングは対応可能です。",
    ],
  },
  {
    keyword: "週中稼働",
    contents: [
      "水曜・木曜を中心に活動しています。",
      "週中に稼働日を集中させています。",
    ],
  },
];
